import React, { useState, useEffect } from 'react';
const API = process.env.REACT_APP_API_URL;

const cleanPhone = (num) => {
    let n = String(num).replace(/\D/g, '');
    if (!n.startsWith('91') && !n.startsWith('1') && !n.startsWith('44')) n = '91' + n;
    return n;
};

const Devices = () => {
    const [devices, setDevices] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [addPhone, setAddPhone] = useState('');
    const [showMsgModal, setShowMsgModal] = useState(false);
    const [deviceId, setDeviceId] = useState('');
    const [targetNumber, setTargetNumber] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [phoneInputs, setPhoneInputs] = useState({});

    const fetchDevices = async () => {
        try {
            const res = await fetch(`${API}/api/devices`);
            const data = await res.json();
            if (Array.isArray(data)) setDevices(data);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchDevices();
        const t = setInterval(fetchDevices, 2000);
        return () => clearInterval(t);
    }, []);

    const handleAdd = async () => {
        if (!addPhone.trim()) return alert('Enter phone number');
        const phone = cleanPhone(addPhone);
        try {
            const res = await fetch(`${API}/api/devices/add`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ deviceId: phone, phoneNumber: phone })
            });
            const result = await res.json();
            if (result.success) {
                setAddPhone('');
                setShowModal(false);
                fetchDevices();
            } else {
                alert(result.error);
            }
        } catch {
            alert('Server error');
        }
    };

    const handleReconnect = async (id) => {
        try {
            const res = await fetch(`${API}/api/devices/reconnect`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ deviceId: id })
            });
            const result = await res.json();
            if (!result.success) alert(result.error);
            fetchDevices();
        } catch {
            alert('Reconnect failed');
        }
    };

    const handleRemove = async (id) => {
        if (!window.confirm(`Remove ${id}?`)) return;
        try {
            const res = await fetch(`${API}/api/devices/remove`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ deviceId: id })
            });
            const result = await res.json();
            if (result.success) fetchDevices();
            else alert(result.error);
        } catch {
            alert('Remove failed');
        }
    };

    const handlePairCode = async (id) => {
        const phone = cleanPhone(phoneInputs[id] || '');
        if (!phone) return alert('Enter phone number');
        try {
            const res = await fetch(`${API}/api/devices/pair-code`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ deviceId: id, phoneNumber: phone })
            });
            const result = await res.json();
            if (result.success) fetchDevices();
            else alert(result.error);
        } catch {
            alert('Pair code failed');
        }
    };

    const handleSend = async () => {
        if (!targetNumber.trim()) return alert('Enter target number');
        const number = cleanPhone(targetNumber);
        const hasImage = imageUrl.trim() !== '';
        const url = hasImage ? `${API}/api/send-image` : `${API}/api/send`;
        const body = {
            deviceId,
            number,
            message: `Hello from ${deviceId}! Demo message from React Dashboard.`
        };
        if (hasImage) body.imageUrl = imageUrl.trim();

        try {
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'my_secret_key_123'
                },
                body: JSON.stringify(body)
            });
            const result = await res.json();
            if (result.success) {
                alert('Message sent!');
                setShowMsgModal(false);
                setTargetNumber('');
                setImageUrl('');
            } else {
                alert(result.error || result.details || 'Send failed');
            }
        } catch {
            alert('Send failed');
        }
    };

    return (
        <div className="wa-page">
            <style>{`
                .wa-page {
                    min-height: 100%;
                    background: #F8F9FA;
                    padding: 24px;
                }

                .wa-page-title {
                    font-size: 1.75rem;
                    font-weight: 700;
                    color: #333333;
                }

                .wa-card {
                    background: #FFFFFF;
                    border-radius: 16px;
                    border: 1px solid #E5E7EB;
                    box-shadow: 0 4px 16px rgba(30, 58, 95, 0.06);
                    transition: all 0.3s ease;
                }

                .wa-card:hover {
                    box-shadow: 0 8px 24px rgba(30, 58, 95, 0.1);
                    transform: translateY(-2px);
                    background: #F0F5FA;
                }

                .wa-btn-success {
                    background: #3BA949 !important;
                    border: none !important;
                    color: #FFFFFF !important;
                }

                .wa-btn-success:hover {
                    background: #339940 !important;
                }

                .wa-modal-overlay {
                    position: fixed;
                    top: 0; left: 0;
                    width: 100%; height: 100%;
                    background: rgba(30, 58, 95, 0.5);
                    backdrop-filter: blur(4px);
                    z-index: 1050;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 16px;
                }

                .wa-modal {
                    background: #FFFFFF;
                    padding: 28px;
                    border-radius: 16px;
                    width: 100%;
                    max-width: 400px;
                    border: 1px solid #E5E7EB;
                    box-shadow: 0 20px 48px rgba(30, 58, 95, 0.18);
                }

                .wa-modal h5 {
                    color: #333333;
                    font-weight: 700;
                }

                .wa-form-control {
                    border: 1.5px solid #E5E7EB;
                    border-radius: 12px;
                    background: #F8F9FA;
                    color: #333333;
                }

                .wa-form-control:focus {
                    border-color: #1A73E8;
                    box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.12);
                    background: #FFFFFF;
                }

                .wa-form-control::placeholder {
                    color: #7A869A;
                }

                @media (max-width: 768px) {
                    .wa-page { padding: 16px; }
                    .wa-page-title { font-size: 1.35rem; }
                    .page-header-row { flex-direction: column; align-items: stretch !important; }
                    .page-header-row .btn { width: 100%; }
                }
            `}</style>

            <div className="d-flex justify-content-between align-items-center mb-4 page-header-row">
                <h2 className="wa-page-title">WhatsApp Devices</h2>
                <button className="btn wa-btn-success rounded-pill px-4" onClick={() => setShowModal(true)}>+ Link WhatsApp</button>
            </div>

            <div className="row g-3">
                {devices.length === 0 ? (
                    <p className="text-muted">No devices. Click Link WhatsApp.</p>
                ) : devices.map((d) => (
                    <div className="col-12 col-md-6 col-lg-4" key={d.id}>
                        <div className="wa-card p-3 h-100">
                            <h5>+{d.name}</h5>
                            {d.error && <div className="alert alert-danger py-1 small">{d.error}</div>}

                            {d.status === 'INITIALIZING' && (
                                <p><span className="spinner-border spinner-border-sm text-success" /> Starting...</p>
                            )}

                            {d.status === 'WAITING_FOR_QR' && (
                                <>
                                    {d.pairingCode ? (
                                        <div className="alert alert-info text-center">
                                            <small>Pairing code</small>
                                            <h3>{d.pairingCode.match(/.{1,4}/g)?.join('-')}</h3>
                                        </div>
                                    ) : (
                                        <>
                                            <img
                                                className="img-fluid mb-2"
                                                src={d.qrImage || `${API}/api/qr-image?data=${encodeURIComponent(d.qr)}`}
                                                alt="QR"
                                            />
                                            <div className="input-group input-group-sm mb-2">
                                                <input
                                                    className="form-control"
                                                    placeholder="9876543210"
                                                    value={phoneInputs[d.id] || ''}
                                                    onChange={(e) => setPhoneInputs({ ...phoneInputs, [d.id]: e.target.value })}
                                                />
                                                <button className="btn btn-outline-primary" onClick={() => handlePairCode(d.id)}>Get Code</button>
                                            </div>
                                        </>
                                    )}
                                    <span className="badge bg-warning text-dark">Waiting</span>
                                </>
                            )}

                            {d.status === 'CONNECTED' && (
                                <>
                                    <p className="text-success fw-bold">Connected</p>
                                    <button className="btn btn-primary btn-sm w-100 mb-2" onClick={() => { setDeviceId(d.id); setShowMsgModal(true); }}>
                                        Send Message
                                    </button>
                                </>
                            )}

                            {d.status === 'DISCONNECTED' && (
                                <>
                                    <p className="text-danger">Disconnected</p>
                                    <button className="btn btn-warning btn-sm w-100 mb-2" onClick={() => handleReconnect(d.id)}>Reconnect</button>
                                </>
                            )}

                            <button className="btn btn-outline-danger btn-sm w-100" onClick={() => handleRemove(d.id)}>Remove</button>
                        </div>
                    </div>
                ))}
            </div>

            {showModal && (
                <div className="wa-modal-overlay">
                    <div className="wa-modal">
                        <h5>Link WhatsApp</h5>
                        <input className="form-control wa-form-control my-3" placeholder="9876543210 (auto +91)" value={addPhone} onChange={(e) => setAddPhone(e.target.value)} />
                        <div className="text-end">
                            <button className="btn btn-light me-2 rounded-pill px-3" onClick={() => setShowModal(false)}>Cancel</button>
                            <button className="btn wa-btn-success rounded-pill px-3" onClick={handleAdd}>Generate Code</button>
                        </div>
                    </div>
                </div>
            )}

            {showMsgModal && (
                <div className="wa-modal-overlay">
                    <div className="wa-modal">
                        <h5>Send Message</h5>
                        <p className="small text-muted">From: +{deviceId}</p>
                        <input className="form-control wa-form-control mb-2" placeholder="Target number" value={targetNumber} onChange={(e) => setTargetNumber(e.target.value)} />
                        <input className="form-control wa-form-control mb-3" placeholder="Image URL (optional)" value={imageUrl} onChange={(e) => setImageUrl(e.target.value)} />
                        <div className="text-end">
                            <button className="btn btn-light me-2 rounded-pill px-3" onClick={() => setShowMsgModal(false)}>Cancel</button>
                            <button className="btn btn-primary rounded-pill px-3" style={{ background: '#3BA949', border: 'none' }} onClick={handleSend}>Send</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Devices;
